import * as request from 'superagent';

import { FileType } from '../../shared/fileUpload';
import { get, post } from '../redux/api';
import type { FileUploadRequest } from '../../typings/api';
import type { FileUploadMetadata, Team } from '../types';

type BuildPayload = {
  selectedTeams: Array<Pick<Team, 'id' | 'name' | 'organizationId'>>;
  archives: FileUploadMetadata[];
  forceRebuild?: boolean;
};

/**
 * uploadFile will upload @file to @url. An optional `onProgress` function may be passed in
 * if consumers want to keep track of the progress of the upload (ex. a Progress Bar in the UI)
 *
 * @param {File} file being uploaded to the @url
 * @param {string} url @url where file is being uploaded to
 * @param {(progress: superagent.ProgressEvent) => void} onProgress A function that is passed a `superagent.ProgressEvent` object on the `progress` event of `request.put`
 */
export async function uploadFile(
  file: File,
  url: string,
  onProgress?: (progress: request.ProgressEvent) => void,
): Promise<void> {
  await request.put(url)
    .set('Content-Type', 'binary/octet-stream')
    .send(file)
    .on('progress', progressEvent => {
      if (onProgress) {
        onProgress(progressEvent);
      }
    });
}

export async function getSignedUrl(
  packageSpec: string,
  revision: string,
  fileType: FileType = FileType.Archive,
): Promise<string> {
  const res = await get<{signedUrl: string}>(
    '/api/components/signed_url',
    false,
    {
      packageSpec: encodeURIComponent(packageSpec),
      revision: encodeURIComponent(revision),
      fileType,
    },
  );

  return res?.data?.signedUrl;
}

/**
 * trigger builds for new components
 */
export async function triggerBuilds(
  payload: BuildPayload,
  query?: FileUploadRequest,
): Promise<void> {
  await post<BuildPayload, void>(
    '/api/components/build',
    payload,
    {
      query,
    },
  );
}
